/* IMPORT */
import Abstract from './abstract.js';
/* MAIN */
class AbstractOutput extends Abstract {
}
/* EXPORT */
export default AbstractOutput;
